import { useMutation, useQueryClient } from '@tanstack/react-query';
import { welcomeCouponQueryKey } from 'entities/coupon';
import { ApiError, MEMBER_DETAIL_QUERY_KEY } from 'shared/api';

import {
  patchMemberName,
  patchPassword,
  postCompleteProfile,
  postEmailCertification,
  postGoogleLogin,
} from './service';

export const usePatchPassword = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: (error: string) => void;
}) => {
  return useMutation({
    mutationFn: patchPassword,

    onSuccess: () => {
      onSuccess && onSuccess();
    },

    onError: (error) => {
      if (error instanceof ApiError) {
        onError(error.message);
      }
    },
  });
};

export const usePostEmailCertification = ({
  onError,
  onSuccess,
}: {
  onError: (error: string) => void;
  onSuccess?: () => void;
}) => {
  return useMutation({
    mutationFn: async (email: string) => {
      return postEmailCertification(email);
    },

    onSuccess: () => {
      onSuccess && onSuccess();
    },

    onError: (error) => {
      if (error instanceof ApiError) {
        onError(error.message);
      }
    },
  });
};

export const usePostGoogleLogin = () => {
  return useMutation({ mutationFn: postGoogleLogin });
};

export const usePostCompleteProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postCompleteProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MEMBER_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: welcomeCouponQueryKey });
    },
    onError: (error) => {
      if (error instanceof ApiError && error.errorCode === 'PROFILE_ALREADY_COMPLETED') {
        queryClient.invalidateQueries({ queryKey: MEMBER_DETAIL_QUERY_KEY });
        queryClient.invalidateQueries({ queryKey: welcomeCouponQueryKey });
      }
    },
  });
};

export const usePatchMemberName = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: patchMemberName,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MEMBER_DETAIL_QUERY_KEY });
    },
  });
};
